import { initialsValue } from "../../../helpers";
import Image from "../Image";
import Indentification from "../Indentification";

export default function ChatHeader({ info }) {
  const name = `${info?.firstName} ${info?.lastName}`;
  return (
    <div className="flex justify-between items-center px-4 py-2 border-b border-slate-300 bg-slate-200">
      <div className="flex items-center gap-2">
        <div className="rounded-full bg-chestnut-rose/40 w-12 min-w-12 h-12 flex-grow-0 overflow-hidden">
          {info?.image?.url ? (
            <Image effect={"fade"} src={info?.image?.url} alt={name} />
          ) : (
            <Indentification
              initial={initialsValue(name)}
              initialClass="!text-xl"
              className={"w-full h-full"}
            />
          )}
        </div>
        <div className="-space-y-1">
          <p className="font-bold text-lg">{name}</p>
          <p className="font-medium text-xs text-shades-05">{info?.email}</p>
          {/* <p className="text-sm text-chestnut-rose">Dimas Eza Typing...</p> */}
        </div>
      </div>
      {/* <div className="flex space-x-2">
        <div className="w-8 h-8 rounded-full bg-chestnut-rose text-white flex items-center justify-center text-sm font-bold">
          +4
        </div>
      </div> */}
    </div>
  );
}
